import React from "react";
import "./AvailHotelList.scss";
import AvailHotelCard from "../AvailHotelCard";

const AvailHotelList = ({
  resultForData,
  availHotelList,
  hanldeSetAvailHotelList,
}) => {
  console.log("availHotelList", availHotelList);
  const handleUpdateHotelCount = (index, roomCount) => {
    let tempHotelList = [...availHotelList];
    if (tempHotelList[index].currentAvailCount - roomCount >= 0) {
      tempHotelList[index].currentAvailCount =
        tempHotelList[index].currentAvailCount - roomCount;
    }
    hanldeSetAvailHotelList(tempHotelList);
  };
  return (
    <div className="AvailHotelList">
      <div className="AvailHotelList__content-wrapper">
        <div className="AvailHotelList__header">
          <h2>{`Hotels in ${resultForData.city}`}</h2>
          <div className="result-desc-container">
            <div className="desc-2">
              <p>{`Adult: ${resultForData.adultCount},`}</p>
              <p>{`Children: ${resultForData.childrenCount},`}</p>
              <p>{`Room: ${resultForData.roomCount}`}</p>
            </div>
            <div className="desc-1">
              <p>{`${resultForData.checkIn} | ${resultForData.checkOut}`}</p>
            </div>
          </div>
        </div>
        <div className="hotel-list-wrapper">
          {availHotelList?.length === 0 && <p>No Hotels Available</p>}
          {availHotelList?.map((hotelData, index) => {
            return (
              <AvailHotelCard
                data={hotelData}
                resultForData={resultForData}
                handleUpdateHotelCount={(roomCount) =>
                  handleUpdateHotelCount(index, roomCount)
                }
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AvailHotelList;
